<section id="mass-os-provider" class="mass-os-provider mass-os-card">
  <header class="mass-os-card__header">
    <div class="mass-os-card__icon" aria-hidden="true">
      <mat-icon>storefront</mat-icon>
    </div>
    <div class="mass-os-card__text">
      <h3 class="mass-os-card__title">Proveedor</h3>
      <p class="mass-os-card__context">
        Selecciona el proveedor de los servicios a generar.
      </p>
    </div>
  </header>

  <div class="mass-os-field-group">
    <label class="mass-os-label"
      >Proveedor <span class="mass-os-label__req">*</span></label
    >

    <div class="mass-os-provider-dropdown" #providerDropdown>
      <button
        type="button"
        class="mass-os-provider-dropdown__trigger"
        [class.mass-os-provider-dropdown__trigger--open]="providerDropdownOpen"
        [class.mass-os-provider-dropdown__trigger--error]="!!providerError"
        (click)="toggleProviderDropdown()"
      >
        <span *ngIf="selectedProvider">{{ selectedProvider.name }}</span>
        <span *ngIf="!selectedProvider && !isLoadingProviders" class="mass-os-provider-dropdown__placeholder">Seleccionar proveedor</span>
        <mat-progress-spinner
          *ngIf="isLoadingProviders"
          diameter="16"
          mode="indeterminate"
          class="mass-os-provider-dropdown__spinner"
        ></mat-progress-spinner>
        <i-tabler name="chevron-down" class="mass-os-provider-dropdown__arrow"></i-tabler>
      </button>

      <div class="mass-os-provider-dropdown__panel" *ngIf="providerDropdownOpen">
        <div class="mass-os-provider-dropdown__search">
          <input
            type="text"
            placeholder="Buscar proveedor..."
            autocomplete="off"
            [value]="providerSearch"
            (input)="providerSearch = $any($event.target).value"
            autofocus
          />
          <i-tabler name="search" class="mass-os-provider-dropdown__search-icon"></i-tabler>
        </div>

        <div class="mass-os-provider-dropdown__list">
          <button
            *ngFor="let provider of filteredProviders"
            type="button"
            class="mass-os-provider-dropdown__option"
            [class.mass-os-provider-dropdown__option--selected]="provider.id === providerId"
            (click)="onProviderChange(provider.id)"
          >
            {{ provider.name }}
          </button>

          <span class="mass-os-provider-dropdown__empty" *ngIf="!filteredProviders.length">
            Sin resultados para "{{ providerSearch }}"
          </span>
        </div>
      </div>
    </div>

    <span class="mass-os-date-hint" role="alert">{{ providerError }}</span>

    <p class="mass-os-provider-period__terms" *ngIf="selectedProvider">
      <mat-icon class="mass-os-provider-period__terms-icon">schedule</mat-icon>
      <span class="mass-os-provider-period__terms-kicker">Proveedor</span>
      <span class="mass-os-provider-period__terms-name">{{ selectedProvider.name }}</span>
    </p>
  </div>
</section>

<section id="mass-os-periodo" class="mass-os-periodo mass-os-card">
  <header class="mass-os-card__header">
    <div class="mass-os-card__icon" aria-hidden="true">
      <mat-icon>calendar_month</mat-icon>
    </div>
    <div class="mass-os-card__text">
      <h3 class="mass-os-card__title">Periodo</h3>
      <p class="mass-os-card__context">
        Define el periodo de las órdenes de servicio a generar.
      </p>
    </div>
  </header>

  <div class="mass-os-field-group">
    <label class="mass-os-label">
      Periodo de Órdenes de Servicio <span class="mass-os-label__req">*</span>
    </label>

    <mat-radio-group
      class="mass-os-provider-period__mode"
      [value]="periodMode"
      (change)="onPeriodModeChange($event.value)"
    >
      <mat-radio-button value="range">Por Rango de Fechas</mat-radio-button>
      <mat-radio-button value="month">Por Mes</mat-radio-button>
    </mat-radio-group>

    <div class="mass-os-provider-period__panel" *ngIf="periodMode === 'range'">
      <div class="mass-os-range-box">
        <div class="mass-os-date-cell">
          <label class="mass-os-date-label"
            >Desde <span class="mass-os-label__req">*</span></label
          >
          <mat-form-field
            appearance="outline"
            class="mass-os-date-field"
            [class.mass-os-field--error]="!!rangeStartError"
            [class.is-filled]="!!rangeStart"
          >
            <input
              matInput
              [matDatepicker]="startPicker"
              [max]="rangeEnd || null"
              [value]="rangeStart"
              (dateChange)="onRangeStartChange($event.value)"
              placeholder="Día/Mes/Año"
            />
            <i-tabler
              name="calendar-month"
              class="mass-os-date-field__trigger"
              matSuffix
              (click)="startPicker.open()"
              role="button"
              tabindex="0"
              (keydown.enter)="startPicker.open()"
              (keydown.space)="startPicker.open()"
            ></i-tabler>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>
          <span
            class="mass-os-date-hint"
            [class.mass-os-date-hint--error]="!!rangeStartError"
            role="alert"
            >{{ rangeStartError }}</span
          >
        </div>

        <i-tabler
          name="arrow-right"
          class="mass-os-range-arrow"
          aria-hidden="true"
        ></i-tabler>

        <div class="mass-os-date-cell">
          <label class="mass-os-date-label"
            >Hasta <span class="mass-os-label__req">*</span></label
          >
          <mat-form-field
            appearance="outline"
            class="mass-os-date-field"
            [class.mass-os-field--error]="!!rangeEndError"
            [class.is-filled]="!!rangeEnd"
          >
            <input
              matInput
              [matDatepicker]="endPicker"
              [min]="rangeStart || null"
              [value]="rangeEnd"
              (dateChange)="onRangeEndChange($event.value)"
              placeholder="Día/Mes/Año"
            />
            <i-tabler
              name="calendar-month"
              class="mass-os-date-field__trigger"
              matSuffix
              (click)="endPicker.open()"
              role="button"
              tabindex="0"
              (keydown.enter)="endPicker.open()"
              (keydown.space)="endPicker.open()"
            ></i-tabler>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>
          <span
            class="mass-os-date-hint"
            [class.mass-os-date-hint--error]="!!rangeEndError"
            role="alert"
            >{{ rangeEndError }}</span
          >
        </div>
      </div>
    </div>

    <div class="mass-os-provider-period__panel" *ngIf="periodMode === 'month'">
      <div class="mass-os-chip-block">
        <span class="mass-os-chip-block__title">Año</span>
        <div class="mass-os-chip-row">
          <button
            *ngFor="let yearOption of years"
            type="button"
            class="mass-os-chip"
            [class.mass-os-chip--selected]="year === yearOption"
            (click)="onYearChange(yearOption)"
          >
            {{ yearOption }}
          </button>
        </div>
      </div>

      <div class="mass-os-chip-block">
        <span class="mass-os-chip-block__title">Mes</span>
        <div class="mass-os-chip-row">
          <button
            type="button"
            class="mass-os-chip"
            [class.mass-os-chip--selected]="isAllYear"
            (click)="toggleAllYear()"
          >
            Todo el año
          </button>
          <button
            *ngFor="let month of monthsList"
            type="button"
            class="mass-os-chip"
            [class.mass-os-chip--selected]="months.includes(month.value)"
            (click)="toggleMonth(month.value)"
          >
            {{ month.label }}
          </button>
        </div>
      </div>

      <span class="mass-os-date-hint" role="alert">{{ monthsError }}</span>
    </div>
  </div>
</section>
